import '@angular/common/locales/pt';
import { registerLocaleData } from '@angular/common';
import _default from '@angular/common/locales/es-CO';
import { environment } from '../environments/environment';
import { loadResources } from './app.config';
// tslint:disable-next-line
registerLocaleData(_default, 'es-CO');
var ɵ0 = environment.sdkObjectMock, ɵ1 = environment.analyticsObjectMock, ɵ2 = loadResources;
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
export { ɵ0, ɵ1, ɵ2 };
